import state from './state'
export default {
  state,
  mutations: {
    updateIsAppTransparent(state, flag) {
      state.isAppTransparent = flag
    },
    setNavAssistantEnabled(state, flag) {
      state.navAssistantEnabled = flag
    },
  },
  actions: {},
  getters: {
    isAppTransparent: (state) => state.isAppTransparent,
    enableNavAssistant: (state) => state.navAssistantEnabled === true,
  },
}



// WEBPACK FOOTER //
// ./src/store/app/index.js